import ApartmentIcon from '@mui/icons-material/Apartment';
import PersonIcon from '@mui/icons-material/Person';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Box, IconButton, Tooltip } from '@mui/material';
import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Palette } from 'Palette';

export interface CardViewLinkHrefs {
  investor?: string;
  contact?: string;
  fund?: string;
}

const CARD_VIEW_LINKS_CLASS = 'card-view-links';

export const revealCardViewLinksOnHoverSx = {
  [`& .${CARD_VIEW_LINKS_CLASS}`]: { display: 'none' },
  [`&:hover .${CARD_VIEW_LINKS_CLASS}, &:focus-within .${CARD_VIEW_LINKS_CLASS}`]: {
    display: 'flex',
  },
  '@media (hover: none)': {
    [`& .${CARD_VIEW_LINKS_CLASS}`]: { display: 'flex' },
  },
};

const LINKS: Array<{
  key: keyof CardViewLinkHrefs;
  title: string;
  Icon: typeof VisibilityIcon;
}> = [
  { key: 'investor', title: 'View Investor', Icon: VisibilityIcon },
  { key: 'contact', title: 'View Contact', Icon: PersonIcon },
  { key: 'fund', title: 'View Fund', Icon: ApartmentIcon },
];

export default function CardViewLinks({ hrefs }: { hrefs?: CardViewLinkHrefs }) {
  const links = LINKS.filter(({ key }) => hrefs?.[key]);
  if (links.length === 0) {
    return null;
  }

  return (
    <Box className={CARD_VIEW_LINKS_CLASS} sx={{ display: 'flex', alignItems: 'center' }}>
      {links.map(({ key, title, Icon }) => (
        <Tooltip key={key} title={title}>
          <IconButton
            size="small"
            component={RouterLink}
            to={hrefs![key]!}
            aria-label={title}
            sx={{ padding: '2px', color: Palette.default.disabledText }}
          >
            <Icon sx={{ fontSize: '0.875rem' }} />
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
}
